/*
 * @Author: Dzy
 * @Date: 2022-07-18 10:52:09
 * @LastEditors: Dzy
 * @LastEditTime: 2022-09-14 22:19:45
 * @Description: Pina数据统一封装
 */
import { useAuthStore } from './authStore'
import { useConfigStore } from './configStore'
import { useTokenStore } from './tokenStore'
import { useDictionaryStore } from './dictionaryStore'
import { useTempStore } from './tempStore'

export default function useStore() {
  return {
    auth: useAuthStore(),
    config: useConfigStore(),
    userToken: useTokenStore(),
    temp: useTempStore(),
    dic: useDictionaryStore()
  }
}
